/**
 * Extracted from the legacy modals/NewIntegration/GoogleIntegrationForm.js
 * (deleted with the old connect/edit modals) — AvailableIntegrations' Google
 * entry still needs this for its `help` field.
 */
import React from "react";
import appConfig from "../../../appConfig";
import HelpAnchor from "../component/HelpAnchor";
import FeatureFlag from "../component/FeatureFlag";

export const GoogleIntegrationHelp = () => (
  <FeatureFlag name={"gcalWelcomeInfo"}>
    <p>
      To learn more about the Google Calendar integration, please click on{" "}
      <HelpAnchor
        href={`${appConfig.helpdeskAddress}/en/articles/5669866-display-church-integrations-how-to-set-them-up`}
        target="_blank"
      >
        this address
      </HelpAnchor>
      .
    </p>
  </FeatureFlag>
);

export default GoogleIntegrationHelp;
